import { render, staticRenderFns } from "./EditBuyerProfile.vue?vue&type=template&id=091a5adc&scoped=true"
import script from "./EditBuyerProfile.vue?vue&type=script&lang=js"
export * from "./EditBuyerProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "091a5adc",
  null
  
)

export default component.exports